import { render, staticRenderFns } from "./VrstaTeme2Create.vue?vue&type=template&id=16df139c&scoped=true&"
import script from "./VrstaTeme2Create.vue?vue&type=script&lang=js&"
export * from "./VrstaTeme2Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df139c",
  null
  
)

export default component.exports